import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Checkbox, FormControlLabel } from "@mui/material";
import parse from "html-react-parser";
import { sxCheckbox, sxCheckboxContrast } from "../../../assets/styles/CommonSxProps";
import PDFViewer from "../../../components/PDFViewer";
import { ContractAeromedicaProps } from "../../../interfaces/props/MeusBeneficios/Aeromedica/ContractAeromedicaProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { sxButton, sxButtonBack } from "./sxProps";

const ContractAeromedica: React.FC<ContractAeromedicaProps> = ({
  contract,
  accessibility,
  acceptedContract,
  setAcceptedContract,
  handleContinue,
  handleBack,
  justView = false,
}) => {

  const { contrastMode, contrastColorAccessibility } = useAccessibility();

  return (
    <>
      <PDFViewer
        file={contract.base64 || ''}
      />
      {!justView &&
        <div>
          <FormControlLabel
            control={<Checkbox
              style={contrastColorAccessibility}
              onChange={() => setAcceptedContract((accepted) => !accepted)}
            />}
            label={parse("Li e aceito os <b>Termos de adesão</b>")}
            sx={contrastMode ? sxCheckboxContrast : sxCheckbox} />
        </div>
      }
      <div className="button-container">
        {!justView &&
          <Button
            variant="contained"
            size="large"
            sx={sxButton}
            style={accessibility.buttonStyleAccessibility}
            disabled={!acceptedContract}
            onClick={handleContinue}
          >
            CONTINUAR
          </Button>
        }
        <Button sx={sxButtonBack} onClick={handleBack}>
          <Box component="span" mr={1}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </Box>
          Voltar
        </Button>
      </div>
    </>
  );
};

export default ContractAeromedica;